module.exports = __webpack_public_path__ + "img/banner_17.46d5bb09.jpg";